import { ReactElement } from "react";
import { IndexPage } from "@/lib/pages/IndexPage";
import { getStaticPaths, getStaticProps } from "@/lib/build/context";
import { StaticPage } from "@/lib/build/StaticPage";
import { FormConfig } from "@evergiving/common/dist/es2015/form";
import { RobotIndexedPage } from "@/lib/misc/RobotIndexedPage";

export default function StaticIndexPage(props: {
  formConfig: FormConfig;
  basePath: string;
}): ReactElement {
  return (
    <StaticPage {...props}>
      {(formConfig: FormConfig) => (
        <RobotIndexedPage>
          <IndexPage formConfig={formConfig} />
        </RobotIndexedPage>
      )}
    </StaticPage>
  );
}

export { getStaticPaths, getStaticProps };
